import { Service } from '../../types/service.type';

const mapRows = (services: Service[]) => {
    const userRow = services.map((service) => {
        return {
            id: service.id,
            data: [
                { type: 'number', value: service.id },
                {
                    type: 'string',
                    value: `${service.type}`,
                },
                {
                    type: 'string',
                    value: `${service.priority}`,
                },
                {
                    type: 'string',
                    value: `${service.name ?? '-'}`,
                },
                {
                    type: 'string',
                    value: `${service.description ?? '-'}`,
                },
                {
                    type: 'string',
                    value: service.stripeId ?? '-',
                },
                {
                    type: 'number',
                    value: service.totalFreeAmbulanceServices ?? '-',
                },
                {
                    type: 'number',
                    value: service.totalFreeTowingServices ?? '-',
                },
                {
                    type: 'number',
                    value: service.towingEligibilityDays ?? '-',
                },
                {
                    type: 'date',
                    value: new Date(service.updatedAt),
                },
            ],
        };
    });

    return userRow;
};

const totalsMapper: { [key: string]: string } = {
    total: 'Total servicios',
    withPlans: 'Servicios con planes',
    withoutPlans: 'Servicios sin planes',
};

export { mapRows, totalsMapper };
